export const hideNumberSpinner = {
	  inputProps: {
			 style: {
					appearance: "textfield",
					MozAppearance: "textfield",
					WebkitAppearance: "textfield"
			 }
	  }
};

export const singleLineText = {
	  overflow: "hidden",
	  textOverflow: "ellipsis",
	  whiteSpace: "nowrap"
};